import { format } from 'date-fns'

import i18n from '@app/i18n'

import getDateFnsLocale from './getDateFnsLocale'


export const formatDate = (ms: number): string => {
  const currentDate = new Date(ms)

  const data = format(currentDate, 'dd MMMM yyyy', {
    locale: getDateFnsLocale(i18n),
  })
  return data
}
